import React from 'react'
import cn from 'classnames'

import LogoIcon from '!!@svgr/webpack!media/logo.svg'

type Props = {
  inverted?: boolean
  className?: string
}

const Logo = ({ inverted, className }: Props) => (
  <LogoIcon
    className={cn('c-logo', { 'c-logo--inverted': inverted }, className)}
  />
)

export default Logo
